// External libraries
import React from 'react';
import { useStoreState } from 'easy-peasy';
import { ErrorIcon } from '@checkout/react-components';

// Internal modules
import { getContent } from '@/lib';
import { LogInLink } from '../Main/Components';
import { useMountLogging } from '@/lib/reactHooks';
import { ErrorContainer, ErrorMessage } from './StyledComponents';

const PageLevelError = () => {
  useMountLogging('PageLevelError');
  const error = useStoreState(({ ui }) => ui.pageLevelError);
  const { merchant } = useStoreState(({ api }) => api.cartDetails);
  const args = [error];

  if (
    error.includes('accountExistsSignup') ||
    error.includes('emailLinkedToFullAccount')
  ) {
    const logInLink = (
      <LogInLink linkType="link">{getContent('billing.loggingIn')}</LogInLink>
    );
    args.push({ logInLink });
  }

  if (error.includes('shippingRegionUnsupported')) {
    args.push({ merchantName: merchant.name });
  }

  return (
    <ErrorContainer data-test-id="page-level-error-container">
      <ErrorIcon />
      <ErrorMessage
        data-error-key={error}
        data-test-id="page-level-error-message"
      >
        {getContent(...args)}
      </ErrorMessage>
    </ErrorContainer>
  );
};

export { PageLevelError };
